import React, { useEffect, useState, useContext, useCallback } from 'react';
import Sidebar from '../../../Sidebar/Sidebar';
import { MdOutlineKeyboardArrowRight, MdFileUpload } from 'react-icons/md';
import { RiArrowGoBackFill } from 'react-icons/ri';
import {
    PendingVendorInvoice,
    UpdateVendorInvoice,
    FileUpload,
    PendingVendorInvoiceOnChnage,
    VendorPaymentEmail,
    GetVendorDetails,
} from '../../../../api';
import LoadingPage from '../../../LoadingPage/LoadingPage';
import { GlobalAlertInfo } from '../../../../App';
import Modal from '../../AlertModal/Modal';

function AddVendorPayment() {
    const [loading, setLoading] = useState(false);
    const [fileLoading, setFileLoading] = useState(false);
    const [todayDate, setTodayDate] = useState('');
    const [count, setCount] = useState(1);
    const [rows, setRows] = useState([0]);
    const [formData, setFormData] = useState([{}]);
    const [pendingInvoices, setPendingInvoices] = useState([]);
    const [indexNo, setIndexNo] = useState(null);
    const [invoiceIndexNo, setInvoiceIndexNo] = useState(null);
    const [files, setFiles] = useState([]);
    const [invoiceNos, setInvoiceNos] = useState([]);
    const [snos, setSnos] = useState([]);
    const [mailData, setMailData] = useState([]);
    const [vendor, setVendor] = useState(null);
    const [fileUploadedSuccess, setFileUploadedSuccess] = useState(false);

    const { tooglevalue, callfun } = useContext(GlobalAlertInfo);

    const getTodayDate = useCallback(() => {
        const date = new Date();
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const org = localStorage.getItem('Database');
                const invoices = await PendingVendorInvoice(org);
                setPendingInvoices(invoices);
                setTodayDate(getTodayDate());
                setLoading(true);
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoading(true);
            }
        };
        fetchData();
    }, [getTodayDate]);

    const addRow = useCallback(() => {
        setCount(prevCount => prevCount + 1);
        setRows(prevRows => [...prevRows, prevRows.length]);
        setFormData(prevFormData => [...prevFormData, {}]);
    }, []);

    const removeRow = useCallback(() => {
        setCount(prevCount => {
            if (prevCount > 1) {
                setRows(prevRows => prevRows.slice(0, -1));
                setFormData(prevFormData => prevFormData.slice(0, -1));
                setFiles(prevFiles => prevFiles.slice(0, -1));
                setInvoiceNos(prevInvoiceNos => prevInvoiceNos.slice(0, -1));
                setSnos(prevSnos => prevSnos.slice(0, -1));
                setMailData(prevMailData => prevMailData.slice(0, -1));
                return prevCount - 1;
            }
            return prevCount;
        });
    }, []);

    const saveToArray = useCallback((index) => {
        const paymentDetail = document.getElementById(`ptydtl-${index}`)?.value || '';
        const paymentAmount = document.getElementById(`ptyamt-${index}`)?.value || '';
        const approvedAmount = document.getElementById(`appramt-${index}`)?.value || '';
        const paymentDate = document.getElementById(`ptydate-${index}`)?.value || '';
        const remark = document.getElementById(`remark-${index}`)?.value || '';

        const obj = {
            sno: snos[index],
            InvoiceNo: invoiceNos[index],
            paymentDetail,
            PaymentAmt: paymentAmount,
            ApprovedAmt: approvedAmount,
            Paymentdate: paymentDate,
            Remark: remark,
            filedata: files[index],
        };

        setFormData(prevFormData => {
            const updatedFormData = [...prevFormData];
            updatedFormData[index] = obj;
            return updatedFormData;
        });
    }, [snos, invoiceNos, files]);

    const handleFileUpload = useCallback(async (event, index) => {
        if (!vendor) {
            callfun('Select vendor first.', 'danger', 'self');
            return;
        }

        setFileLoading(true);
        setFileUploadedSuccess(false);

        try {
            const file = event.target.files[0];
            if (!file) {
                callfun('No file selected', 'warning', 'self');
                return;
            }
            if (file.size > 5 * 1024 * 1024) {
                callfun('File size exceeds 5MB', 'warning', 'self');
                return;
            }

            const data = new FormData();
            data.append('files', file);
            data.append('fileType', 'CHQ');
            data.append('vendorName', vendor);

            const response = await FileUpload(data);
            if (response && response.uploaded && response.uploaded.length > 0) {
                const uploadedUrl = response.uploaded[0];
                
                setFiles(prevFiles => {
                    const updatedFiles = [...prevFiles];
                    updatedFiles[index] = uploadedUrl;
                    return updatedFiles;
                });

                callfun('File uploaded successfully', 'success', 'self');
                setFileUploadedSuccess(true);
                
                // Clear the file input after successful upload
                const fileInput = document.getElementById('inputfile');
                if (fileInput) {
                    fileInput.value = '';
                }
                
                // Save to array after file upload
                setTimeout(() => saveToArray(index), 100);
            } else {
                callfun('File upload failed: Invalid response', 'danger', 'self');
            }
        } catch (err) {
            callfun(`Error uploading file: ${err.message}`, 'danger', 'self');
        } finally {
            setFileLoading(false);
        }
    }, [vendor, callfun, saveToArray]);

    const handleAddVendorInvoice = useCallback(async (e) => {
        e.preventDefault();
        setLoading(false);
        document.getElementById('subnitbtn').disabled = true;

        const org = localStorage.getItem('Database');
        let errorCount = 0;

        for (let i = 0; i < formData.length; i++) {
            if (!formData[i].InvoiceNo || formData[i].InvoiceNo === 'Select Invoice no') {
                callfun('Please select the Invoice no', 'warning', 'self');
                errorCount++;
            } else if (!formData[i].paymentDetail || !formData[i].PaymentAmt) {
                callfun('Please fill all mandatory fields and upload a file', 'warning', 'self');
                errorCount++;
            }
        }

        if (errorCount === 0) {
            const sendMessage = formData.map((item, i) => ({
                invoice_number: mailData[i]?.invoice_no || '',
                invoice_date: mailData[i]?.invoice_date || '',
                invoice_receive_date: mailData[i]?.invoice_date || '',
                invoice_amount: mailData[i]?.invoice_amount || '',
                invoice_upload: mailData[i]?.filedata || '',
                payment_date: item.Paymentdate,
                payment_details: item.paymentDetail,
                payment_amount: item.PaymentAmt,
                payment_link: item.filedata || '',
                mailid: mailData[i]?.company_mailId || '',
                vendor_name: mailData[i]?.vendor_name || '',
                referance_no: mailData[i]?.reference_no || '',
            }));

            try {
                const result = await UpdateVendorInvoice(org, formData, localStorage.getItem('UserId'));
                await Promise.all(sendMessage.map((data) => VendorPaymentEmail(data)));
                setLoading(true);
                if (result === 'Data Updated') {
                    callfun('Vendor Payment Added', 'success', '/TotalVendorPayment');
                } else {
                    callfun('Server Error', 'danger', 'self');
                    document.getElementById('subnitbtn').disabled = false;
                }
            } catch (err) {
                callfun(`Error: ${err.message}`, 'danger', 'self');
                document.getElementById('subnitbtn').disabled = false;
                setLoading(true);
            }
        } else {
            setLoading(true);
            document.getElementById('subnitbtn').disabled = false;
        }
    }, [formData, mailData, callfun]);

    const handleChangeInvoiceDetail = useCallback(async (data) => {
        const { sno, invoice_no, InvoiceAmt, Index, refno, invoice_date, invoice_url, vendor_name } = data;
        
        // Update all states in a single batch
        setSnos(prev => {
            const updated = [...prev];
            updated[Index] = sno;
            return updated;
        });
        
        setInvoiceNos(prev => {
            const updated = [...prev];
            updated[Index] = invoice_no;
            return updated;
        });

        // Update DOM elements
        const invAmtElement = document.getElementById(`invamt-${Index}`);
        const apprAmtElement = document.getElementById(`appramt-${Index}`);
        const refNoElement = document.getElementById(`refno-${Index}`);
        const buttonElement = document.getElementById(`button${Index}`);

        if (invAmtElement) invAmtElement.value = InvoiceAmt;
        if (apprAmtElement) apprAmtElement.value = InvoiceAmt;
        if (refNoElement) refNoElement.value = refno;
        if (buttonElement) buttonElement.innerHTML = invoice_no;

        try {
            const vendorDetails = await GetVendorDetails(localStorage.getItem('Database'), vendor_name);
            
            setMailData(prev => {
                const updated = [...prev];
                updated[Index] = {
                    invoice_no,
                    invoice_date,
                    receiving_date: invoice_date,
                    invoice_url,
                    vendor_name: vendorDetails[0]?.vendor_name || vendor_name,
                    company_mailId: vendorDetails[0]?.company_email || '',
                    invoice_amount: InvoiceAmt,
                    reference_no: refno,
                };
                return updated;
            });
            
            setVendor(vendor_name);
        } catch (error) {
            console.error('Error fetching vendor details:', error);
            callfun('Error fetching vendor details', 'warning', 'self');
        }
    }, [callfun]);

    const handleGetInvoiceNo = useCallback(async (e) => {
        try {
            const invoices = await PendingVendorInvoiceOnChnage(localStorage.getItem('Database'), e.target.value);
            setPendingInvoices(invoices);
        } catch (error) {
            console.error('Error searching invoices:', error);
        }
    }, []);

    const handleModalClose = useCallback(() => {
        if (indexNo !== null && !files[indexNo]) {
            callfun('Please upload a file before saving.', 'warning', 'self');
            return;
        }
        if (indexNo !== null) {
            saveToArray(indexNo);
        }
        
        // Clear the file input when modal closes
        const fileInput = document.getElementById('inputfile');
        if (fileInput) {
            fileInput.value = '';
        }
        
        setFileUploadedSuccess(false);
    }, [indexNo, files, callfun, saveToArray]);

    return (
        <>
            {loading ? (
                <Sidebar>
                    <Modal
                        theme={tooglevalue.theme}
                        text={tooglevalue.message}
                        show={tooglevalue.modalshowval}
                        url={tooglevalue.url}
                    />
                    <div className="main_container px-2">
                        <div className="main-inner-container d-flex justify-content-between pt-4 pb-3">
                            <h4>
                                <span className="page-type-head1">
                                    Vendor Payment <MdOutlineKeyboardArrowRight />
                                </span>
                                <span className="page-type-head2">Add Vendor Payment</span>
                            </h4>
                            <button
                                className="btn btn-secondary"
                                onClick={() => (window.location.href = '/TotalVendorPayment')}
                            >
                                Back <RiArrowGoBackFill />
                            </button>
                        </div>
                        <div className="bg-white shadow1-silver rounded15 mt-1 card inner-card pb-3">
                            <header className="card-header d-flex justify-content-between">
                                <h5>Add Vendor Payment</h5>
                                <div>
                                    <button className="btn btn-voilet" onClick={addRow}>
                                        Add row
                                    </button>
                                    <button className="btn btn-danger mx-2" onClick={removeRow}>
                                        Remove row
                                    </button>
                                </div>
                            </header>
                            <article className="card-body">
                                <form className="invoice-form overflow-auto" autoComplete="off" onSubmit={handleAddVendorInvoice}>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Invoice no <span className="text-danger">*</span></th>
                                                <th>Invoice Amount <span className="text-danger">*</span></th>
                                                <th>Payment Detail <span className="text-danger">*</span></th>
                                                <th>Payment Amount <span className="text-danger">*</span></th>
                                                <th>Approved Amount <span className="text-danger">*</span></th>
                                                <th>Payment Date <span className="text-danger">*</span></th>
                                                <th>Remark</th>
                                                <th>Ref no. <span className="text-danger">*</span></th>
                                                <th>Upload </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rows.map((_, index) => (
                                                <tr key={index}>
                                                    <td className="p-0">
                                                        <button
                                                            className="form-control m-0 btn btn-success"
                                                            data-toggle="modal"
                                                            data-target="#invoiceModalCenter"
                                                            id={`button${index}`}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                setInvoiceIndexNo(index);
                                                                setTimeout(() => {
                                                                    const searchElement = document.getElementById('searchInvoice');
                                                                    if (searchElement) searchElement.focus();
                                                                }, 550);
                                                            }}
                                                        >
                                                            {invoiceNos[index] || 'Select'}
                                                        </button>
                                                    </td>
                                                    <td className="p-0">
                                                        <input
                                                            type="number"
                                                            id={`invamt-${index}`}
                                                            className="form-control m-0"
                                                            disabled
                                                            onBlur={() => saveToArray(index)}
                                                        />
                                                    </td>
                                                    <td className="p-0">
                                                        <input
                                                            type="text"
                                                            id={`ptydtl-${index}`}
                                                            className="form-control m-0"
                                                            onBlur={() => saveToArray(index)}
                                                        />
                                                    </td>
                                                    <td className="p-0">
                                                        <input
                                                            step="0.001"
                                                            type="number"
                                                            id={`ptyamt-${index}`}
                                                            className="form-control m-0"
                                                            onBlur={() => saveToArray(index)}
                                                        />
                                                    </td>
                                                    <td className="p-0">
                                                        <input
                                                            type="number"
                                                            step="0.001"
                                                            id={`appramt-${index}`}
                                                            className="form-control m-0"
                                                            onBlur={() => saveToArray(index)}
                                                        />
                                                    </td>
                                                    <td className="p-0">
                                                        <input
                                                            type="date"
                                                            id={`ptydate-${index}`}
                                                            className="form-control m-0"
                                                            defaultValue={todayDate}
                                                            onBlur={() => saveToArray(index)}
                                                        />
                                                    </td>
                                                    <td className="p-0">
                                                        <input
                                                            type="text"
                                                            id={`remark-${index}`}
                                                            className="form-control m-0"
                                                            onBlur={() => saveToArray(index)}
                                                        />
                                                    </td>
                                                    <td className="p-0">
                                                        <input
                                                            type="text"
                                                            id={`refno-${index}`}
                                                            className="form-control m-0"
                                                            disabled
                                                            onBlur={() => saveToArray(index)}
                                                        />
                                                    </td>
                                                    <td className="p-0">
                                                        <button
                                                            className="form-control m-0"
                                                            data-toggle="modal"
                                                            data-target="#exampleModalCenter"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                setIndexNo(index);
                                                            }}
                                                        >
                                                            <MdFileUpload 
                                                                style={{ 
                                                                    fontSize: '25px', 
                                                                    color: files[index] ? 'green' : '' 
                                                                }} 
                                                            />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="btn_div">
                                        <button className="btn btn-voilet" id="subnitbtn" type="submit">
                                            Add Vendor Payment
                                        </button>
                                        <button type="reset" className="btn btn-secondary mx-2">
                                            Reset
                                        </button>
                                    </div>
                                </form>
                            </article>
                        </div>

                        {/* Upload Modal */}
                        <div
                            className="modal fade"
                            id="exampleModalCenter"
                            tabIndex="-1"
                            role="dialog"
                            aria-labelledby="exampleModalCenterTitle"
                            aria-hidden="true"
                        >
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="exampleModalLongTitle">
                                            Upload Invoice
                                        </h5>
                                    </div>
                                    <div className="modal-body">
                                        <input
                                            type="file"
                                            id="inputfile"
                                            onChange={(e) => handleFileUpload(e, indexNo)}
                                            disabled={fileLoading}
                                        />
                                        {fileLoading && <span>Uploading...</span>}
                                    </div>
                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            data-dismiss="modal"
                                            disabled={fileLoading}
                                            onClick={() => {
                                                // Clear file input when closing without saving
                                                const fileInput = document.getElementById('inputfile');
                                                if (fileInput) {
                                                    fileInput.value = '';
                                                }
                                                setFileUploadedSuccess(false);
                                            }}
                                        >
                                            Close
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-success"
                                            data-dismiss="modal"
                                            disabled={!fileUploadedSuccess || fileLoading}
                                            onClick={handleModalClose}
                                        >
                                            Close & Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Invoice Modal */}
                        <div
                            className="modal fade"
                            id="invoiceModalCenter"
                            tabIndex="-1"
                            role="dialog"
                            aria-labelledby="exampleModalCenterTitle"
                            aria-hidden="true"
                        >
                            <div className="modal-dialog modal-dialog-centered" role="document" style={{ minWidth: '48vw' }}>
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="exampleModalLongTitle">
                                            Select Invoice no
                                        </h5>
                                        <div className="form-group col-md-5">
                                            <input
                                                type="text"
                                                className="form-control col"
                                                placeholder="Search Invoice"
                                                id="searchInvoice"
                                                onChange={handleGetInvoiceNo}
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-body overflow-auto" style={{ maxHeight: '60vh' }}>
                                        <table className="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Vendor</th>
                                                    <th>Account Number</th>
                                                    <th>Invoice Number</th>
                                                    <th>Reference Number</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pendingInvoices.map((item, index) => (
                                                    <tr
                                                        key={index}
                                                        className="vendor-Invoice-list cursor-pointer"
                                                        data-dismiss="modal"
                                                        onClick={() =>
                                                            handleChangeInvoiceDetail({
                                                                sno: item.sno,
                                                                invoice_no: item.invoice_no,
                                                                InvoiceAmt: item.invoice_amt,
                                                                Index: invoiceIndexNo,
                                                                refno: item.reference_no,
                                                                invoice_date: item.date,
                                                                invoice_url: item.uploadInvoice,
                                                                vendor_name: item.vendor,
                                                            })
                                                        }
                                                    >
                                                        <td>{item.vendor}</td>
                                                        <td>{item.account_no}</td>
                                                        <td>{item.invoice_no}</td>
                                                        <td>{item.reference_no}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            data-dismiss="modal"
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Sidebar>
            ) : (
                <LoadingPage />
            )}
        </>
    );
}

export default AddVendorPayment;